import CustomTable from './table';
import { TableColumn, TableSum, TableSumCell } from './styles';

export default CustomTable;
export {
  TableColumn,
  TableSum,
  TableSumCell,
};
